<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center">
      <PageHeader class="text-lg font-medium mr-auto" />
    </div>

    <div class="intro-y mt-5 overflow-auto lg:overflow-visible">
      <TableTestReport
        :loading="loading"
        :downloading="downloading"
        :rows="rows"
        :columns="columns"
        :page="page"
        :per-page="perPage"
        :page-size="pageSize"
        :total-page="totalPage"
        :total-records="totalRecords"
        :downloadable="downloadable"
        :type="type"
        :form="form"
        :officer-list="officerList"
        :bank-account-list="bankAccountList"
        :officer-loading="officerLoading"
        :meta="reportLoanListMeta"
        @onFilter="$emit('onFilter')"
        @onPageChange="$emit('onPageChange', $event)"
        @onPerPageChange="$emit('onPerPageChange', $event)"
        @onDownload="$emit('onDownload')"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageHeader from '@/components/ui/PageHeader';
import TableTestReport from '@/components/ui/TableTestReport';

export default {
  components: {
    PageHeader,
    TableTestReport,
  },

  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    rows: {
      type: Array,
      default: () => [],
    },
    loading: Boolean,
    downloading: Boolean,
    page: Number,
    perPage: Number,
    pageSize: Array,
    totalPage: Number,
    totalRecords: Number,
    type: String,
    downloadable: {
      type: Boolean,
      default: false,
    },
    form: Object,
  },

  data() {
    return {
      bankAccountList: [
        {
          name: 'ЗуунКа',
          number: '5434038785',
        },
        {
          name: 'Солонго',
          number: '5070393445',
        },
      ],
    };
  },

  computed: {
    ...mapGetters(['officerList', 'officerStatus', 'reportLoanListMeta']),
    officerLoading() {
      return this.officerStatus === 'loading';
    },
  },
};
</script>
